import React, { useState, ReactNode } from 'react';
import './TabControl.css';

export interface Tab {
  id: string;
  title: string;
  content: ReactNode;
}

interface TabControlProps {
  tabs: Tab[];
  defaultTabId?: string;
  className?: string;
}

const TabControl: React.FC<TabControlProps> = ({ tabs, defaultTabId, className = '' }) => {
  const [activeTabId, setActiveTabId] = useState(defaultTabId || tabs[0]?.id || '');

  const activeTab = tabs.find(tab => tab.id === activeTabId);

  if (tabs.length === 0) {
    return null;
  }

  return (
    <div className={`tab-control-container ${className}`}>
      {/* Tab Headers */}
      <ul className="tab-control-nav" role="tablist">
        {tabs.map((tab) => (
          <li className="tab-control-item" key={tab.id}>
            <button
              className={`tab-control-button ${activeTabId === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTabId(tab.id)}
              role="tab"
              aria-selected={activeTabId === tab.id}
              type="button"
            >
              {tab.title}
            </button>
          </li>
        ))}
      </ul>

      {/* Tab Content */}
      <div className="tab-control-content">
        <div className="tab-pane active" role="tabpanel">
          {activeTab?.content}
        </div>
      </div>
    </div>
  );
};

export default TabControl;
